import { isNumber } from "lodash";

export class RowValidationErrorModel {
	row: number;
	errors: string[];

	constructor(row: number, errors: string[]) {
		if (isNumber(row)) {
			this.row = row;
		}
		this.errors = errors;
	}

	static createFromValidationErrors(e): Array<RowValidationErrorModel> {
		const errorModel = new Array<RowValidationErrorModel>();

		for (const key in e) {
			if (e.hasOwnProperty(key)) {
				const segments = key.split('.'); // [5].AccountName
				const rowNumber = segments[0].replace("[", "").replace("]", ""); // 5
				const errors = e[key]; // errors array
				errorModel.push(new RowValidationErrorModel(parseInt(rowNumber), errors));
			}
		}

		return errorModel;
	}
}
